var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 50,
    viewBox: "0 0 33 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(-1307 -1251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_15",
    "data-name": "Polygon 15",
    d: "M16.5,0l9.012,2.673,6.151,7.172L33,19.238,29.1,27.87,21.2,33H11.8L3.9,27.87,0,19.238,1.337,9.845,7.488,2.673Z",
    transform: "translate(1307 1251)",
    fill: "#d5ecd9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_16",
    "data-name": "Polygon 16",
    d: "M16.5,0l9.012,2.673,6.151,7.172L33,19.238,29.1,27.87,21.2,33H11.8L3.9,27.87,0,19.238,1.337,9.845,7.488,2.673Z",
    transform: "translate(1307 1260)",
    fill: "#439a63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_17",
    "data-name": "Polygon 17",
    d: "M16.5,0l9.012,2.673,6.151,7.172L33,19.238,29.1,27.87,21.2,33H11.8L3.9,27.87,0,19.238,1.337,9.845,7.488,2.673Z",
    transform: "translate(1307 1268)",
    fill: "#08652a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group3.660713520b75c2b1d7522fc6cf348dde.svg";
export { ForwardRef as ReactComponent };